import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';
import { selectOrderByRLP, selectSkuSearchState, selectSortByRLP, setOrderByTimeline, setSortByTimeline, SkuSearchState, SortOptionsByPageState } from '@emi/shared/state/sku-search';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'via-sku-set-options',
    templateUrl: './sku-set-options.component.html',
    styleUrls: ['./sku-set-options.component.scss'],
})
export class SkuSetOptionsComponent implements OnInit, OnDestroy {

    private skuSearchSubscription: Subscription;
    public disableOptions: boolean;

    constructor(private router: Router, private readonly store: Store<SkuSearchState>, private readonly sortOptionsByPageStore: Store<SortOptionsByPageState>) {}

    public ngOnInit(): void {
        this.skuSearchSubscription = this.store.pipe(select(selectSkuSearchState)).subscribe((state) => {
            this.disableOptions = !(state.skuCount > 0);
        });
    }

    public navigateToConfigureData(): void {
        this.router.navigate([Constants.Routes.SKU_SEARCH_CONFIGURE_DATA_ROUTE]);
    }

    public navigateToSkuPriceHistory(): void {
        this.syncSortOptionFromRLPToTimelinePage();
        this.router.navigate([Constants.Routes.SKU_SEARCH_PRICE_HISTORY]);
    }

    //Pulling through the same sort by option to the timeline page
    public syncSortOptionFromRLPToTimelinePage(): void {
        this.sortOptionsByPageStore.pipe(select(selectSortByRLP),take(1)).subscribe((sortBy) => {
            const sortByRLP = sortBy || '';
            const sortByTLP = sortByRLP === 'lastSeenPrice' ? 'totalRetailers' : sortByRLP;
            this.sortOptionsByPageStore.dispatch(setSortByTimeline({ sortBy: sortByTLP }));
        }); 

        this.sortOptionsByPageStore.pipe(select(selectOrderByRLP), take(1)).subscribe((orderBy) => {
            const orderByRLP = orderBy || '';
            this.sortOptionsByPageStore.dispatch(setOrderByTimeline({ orderBy: orderByRLP }));
        });
    }

    ngOnDestroy(): void {
        this.skuSearchSubscription.unsubscribe();
    }
}
